
import {Component, Vue, Watch} from 'vue-property-decorator'
import CourierInfo from '@/model/modules/CourierInfo'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'
import StealFreightInfo from '@/model/modules/StealFreightInfo'
import StealFreightService from '@/service/modules/StealFreightService'

@Component
export default class PostcodeDataEditor extends Vue {
  item: CourierInfo = new CourierInfo()
  showState: boolean = false
  dataLoadingState: boolean = false
  courierList: CourierInfo[] = []

  listLoadingState: boolean = false
  headerDefine: any = [
    {text: '数据ID', value: 'id'},
    {text: '判断重量', value: 'systemKg'},
    {text: '替换重量', value: 'otherkg'},
    {text: '差值', value: 'difference'}
  ]

  queryLikeResult: BasePageableInfo<StealFreightInfo> = new BasePageableInfo<StealFreightInfo>()
  pageNum: number = 1
  pageSize: number = 20
  pageSizeOptions = [{text: '20条/页', value: 20}, {text: '50条/页', value: 50}, {
    text: '200条/页',
    value: 200
  }, {text: '1000条/页', value: 1000}, {text: '2000条/页', value: 2000}]

  uploadPanelShowState: boolean = false
  uploadingState: boolean = false
  // @ts-ignore
  uploadUrl: string = window.$HOST + '/order/import_postcode'
  uploadHeaders: any = axios.defaults.headers

  mounted() {
  }

  showEditor(item: CourierInfo, saveSuccessCallback: any) {
    this.item = JSON.parse(JSON.stringify(item))
    this.showState = true
    this.loadAllData()
    // @ts-ignore
    this.uploadUrl = window.$HOST + '/order/import_difference?channel=' + this.item.id
  }

  @Watch('pageSize')
  onPageSizeChanged() {
    this.loadAllData()
  }

  @Watch('pageNum')
  loadAllData() {
    this.listLoadingState = true
    StealFreightService.list({courierId: this.item.id}, this.pageNum - 1, this.pageSize)
      .then((result: BasePageableInfo<StealFreightInfo>) => {
        this.queryLikeResult = result
        this.listLoadingState = false
      })
  }

  beforeUpload() {
    this.uploadingState = true
  }

  uploadSuccess(response: any) {
    this.loadAllData()
    this.uploadingState = false
    // @ts-ignore
    this.$refs.uploader.clearFiles()
    if (response.body.length > 0) {
      this.$alert('订单Excel上传完毕，服务器返回了如下提示：<br>\n' + response.body.join('<br>'), '订单Excel上传', {
        confirmButtonText: '我知道了',
        dangerouslyUseHTMLString: true
      })
    } else {
      this.uploadPanelShowState = false
      this.$notify({
        title: 'Excel上传结束',
        message: '上传成功',
        type: 'success'
      })
    }
  }
}
